import styled from '@emotion/styled'

export const LayoutBackground = styled.div`
  ${({ theme }) => `
    background-color: ${theme.colors.grey[1]};
  `}
`


export const LayoutContainer = styled.div`
${({ theme }) => `
  ${theme.breakpoints.desktop} {
    display: grid;
    grid-template-columns: 1fr 45%;
  }
`}
`

export const LayoutMainContent = styled.main`
  display: none;
  ${({ theme }) => `
    ${theme.breakpoints.desktop} {
      display: grid;
      grid-template-rows: 1fr auto;
      min-height: 100vh;
      overflow: hidden;
    }
  `}
`

export const BodyContent = styled.div`
  overflow: auto;
  display: flex;
  flex-direction: column;
`

export const LayoutRightContent = styled.div`
  ${({ theme }) => `
    background-color: ${theme.colors.neutrals.w};
    ${theme.breakpoints.desktop} {
      min-height: 100vh;
      overflow: hidden;
    }
  `}
`
export const LayoutHeaderContainer = styled.header`
  /* istanbul ignore next */
  ${({ theme }) => `
    ${theme.breakpoints.desktop} {
      display: grid;
      grid-template-columns: 1fr 45%;
    }
  `}
`

export const LayoutHeaderContent = styled.div`
  /* istanbul ignore next */
  ${({ theme }) => `
    background-color: ${theme.colors.neutrals.w};
    padding: 24px;
    border-bottom: 1px solid ${theme.colors.grey[2]};

    ${theme.breakpoints.desktop} {
      padding: 16px 64px;
      background-color: transparent;
      border-bottom: none;
      margin-bottom: 10px;
    }
  `}
`

export const LayoutHeaderIcon = styled.img`
  height: 33px;
`

export const LayoutHeaderWhiteContent = styled.div`
  /* istanbul ignore next */
  background-color: ${({ theme }) => theme.colors.neutrals.w};
`

